import PicklistMetadata from "../PicklistMetadata";

// User Groups the current user is a member of (display = Name, value = USID). Sourced client-side from
// SessionContext.getAccount().UserGroups (login-payload list, filtered server-side to the user's own
// memberships). Used for PRIMARY User Group (stewardship owner) pickers. The realm-wide "all user
// groups" list used by the Add-Shared-User-Group picker is a separate picklist ("UserGroupShared").
class UserGroupPicklistMetadata extends PicklistMetadata {
    constructor() {
        super();

        this.name = "UserGroup";
        this.static = true;
        this.companySource = "UserGroups";
        this.useRealm = false;
        this.typeField = "Name";
        this.typeValue = "USID";
        this.allowNoSelection = false;
    }
}

export default UserGroupPicklistMetadata;
